const pad = (value: number, width = 2) => String(value).padStart(width, "0");

/** Local wall-clock time with milliseconds, e.g. 14:03:09.027. */
export const formatTime = (iso: string): string => {
    const date = new Date(iso);
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`;
};

export const formatBytes = (bytes: number): string => {
    if (bytes < 1024) return `${Math.round(bytes)} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KiB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MiB`;
};
